export var MembersOrderBy = {
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT',
  id: 'ID',
  nickname: 'NICKNAME',
  uniqueId: 'UNIQUEID'
};